import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqPermissoes = {
	// listPermission: async function (id, paramValue) {
	// 	return apiServer
	// 		.get(`portal/v1/permissions/${id}/validate`, {
	// 			params: {
	// 				paramValue,
	// 			},
	// 			headers: {
	// 				banco: banco,
	// 			},
	// 		})
	// 		.then((response) => {
	// 			return response;
	// 		})
	// 		.catch((error) => {
	// 			throw error;
	// 		});
	// },
	listPermission: async function (id, paramValue) {
		return apiServer
			.get(`portal/v2/permissions/validate`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listIdPermission: async function (id) {
		return apiServer
			.get(`portal/v1/permissions/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqPermissoes;
